import { useTranslation } from 'react-i18next'
import { Box, Text, CloseButton } from '@chakra-ui/react'
import { colors } from '../../../../utilities/colors'
import useStore from '../../../../store'

const gatePassMaxBytes = 5 * 1024 * 1024
const gatePassAllowedExtensions = ['jpg', 'jpeg', 'png', 'pdf', 'bin', 'heic', 'heif', 'docx', 'doc']

export default function GatePassField({ vehicleId, gatePasses, setGatePasses }) {
  const { t } = useTranslation()
  const setErrMessage = useStore((state) => state.setErrMessage)
  const gatePassUpload = gatePasses?.[vehicleId]

  const handleFile = (file) => {
    if (!file) return
    const extension = file.name.split('.').pop()?.toLowerCase()
    if (!extension || !gatePassAllowedExtensions.includes(extension)) {
      setErrMessage(t('Unsupported file type. Allowed: jpg, jpeg, png, pdf, bin, heic, heif, docx, doc'))
      return
    }
    if (file.size > gatePassMaxBytes) {
      setErrMessage(t('Gate pass exceeds 5 MB'))
      return
    }
    const reader = new FileReader()
    reader.onloadend = () => {
      const result = typeof reader.result === 'string' ? reader.result : ''
      const base64 = result.includes(',') ? result.split(',')[1] : result
      setGatePasses((prev) => ({ ...prev, [vehicleId]: { filename: file.name, base64 } }))
    }
    reader.readAsDataURL(file)
  }

  const handleRemove = () => {
    setGatePasses((prev) => {
      const copy = { ...prev }
      delete copy[vehicleId]
      return copy
    })
  }

  const button = (
    <label className="relative cursor-pointer">
      <span
        className="py-1 px-3 inline-block rounded border-2 text-sm font-semibold"
        style={{ borderColor: colors.green, color: colors.green }}
      >
        {gatePassUpload ? t('Replace') : t('Gate Pass')}
      </span>
      <input
        type="file"
        className="sr-only"
        data-testid={`gate-pass-input-${vehicleId}`}
        onChange={(event) => handleFile(event.target.files?.[0])}
        accept=".jpg,.jpeg,.png,.pdf,.bin,.heic,.heif,.docx,.doc"
      />
    </label>
  )

  const fileRow = gatePassUpload && (
    <Box display="flex" alignItems="center" gap={1} maxW="50vw" minW={0}>
      <Text fontSize="xs" color={colors.grey100} truncate>
        {gatePassUpload.filename}
      </Text>
      <CloseButton
        size="xs"
        color={colors.grey100}
        onClick={handleRemove}
        data-testid={`remove-gate-pass-${vehicleId}`}
        flexShrink={0}
      />
    </Box>
  )

  return gatePassUpload ? fileRow : button
}
